"use client";
import Link from "next/link";
import React from "react";

export const Logo = () => {
  return (
    <Link
      href="/"
      className="font-normal flex space-x-2 items-center text-sm mr-4 text-black px-2 py-1 relative z-20"
    >
      <svg
        className="h-5 w-5 flex-shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C9.5 6 7 8 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 8 14.5 6 12 2Z"
          className="fill-orange-500"
        />
        <path
          d="M12 17C12 17 9 15 9 12.5C9 11.12 10.12 10 11.5 10C11.67 10 11.84 10.02 12 10.05C12.16 10.02 12.33 10 12.5 10C13.88 10 15 11.12 15 12.5C15 15 12 17 12 17Z"
          className="fill-yellow-400"
        />
      </svg>
      <span className="font-semibold text-black dark:text-white">
        Coldfire
      </span>
    </Link>
  );
};
